/* global playTimeApiUrl */
import videojs from 'video.js'
import 'videojs-vtt-thumbnails' // サムネイルプラグイン
import 'videojs-contrib-quality-levels' // 画質選択プラグイン
import 'videojs-hls-quality-selector' // 画質選択プラグイン

import scrollLock from './functions/_scrollLock.js' // スクロールロック
import getCookie from './functions/_cookie-getCookie.js' // Cookie取得
import setCookie from './functions/_cookie-setCookie.js' // Cookie発行
const deviceOS = isDeviceOS()
const skipTimes = [-10, -3, 10, 30]

const videoList = document.getElementsByClassName('js-video')
for (const videoItem of videoList) {
  videoSetup(videoItem)
}

//   ####  #####  ######  ##   ##  #####
//  ##     ##       ##    ##   ##  ##  ##
//   ###   #####    ##    ##   ##  #####
//     ##  ##       ##    ##   ##  ##
//  ####   #####    ##     #####   ##

function videoSetup(videoItem) {
  // 出力する操作ボタン
  let control = [
    { name: 'progressControl' },
    { name: 'playToggle' },
    { name: 'volumePanel', inline: true },
    { name: 'currentTimeDisplay' },
    { name: 'TimeDivider' },
    { name: 'durationDisplay' },
    { name: 'spacer' },
  ]
  if (deviceOS !== 'android') {
    // Android以外はピクチャーインピクチャーボタンを追加
    control.push({ name: 'pictureInPictureToggle' })
  }
  control.push({ name: 'FullscreenToggle' })

  const player = videojs(videoItem, {
    controls: true,
    fluid: true,
    autoplay: false,
    preload: 'none',
    controlBar: {
      children: control,
    },
    html5: {
      hls: {
        overrideNative: !videojs.browser.IS_ANY_SAFARI,
      },
      nativeAudioTracks: false,
      nativeVideoTracks: false,
    },
  })

  const videoSrc = videoItem.dataset.video
  player.src(videoSrc)

  // 画質選択
  // player.hlsQualitySelector({
  //   displayCurrentQuality: true,
  // })

  //  ###    ###   #####   ####      ###    ##
  //  ## #  # ##  ##   ##  ##  ##   ## ##   ##
  //  ##  ##  ##  ##   ##  ##  ##  ##   ##  ##
  //  ##      ##  ##   ##  ##  ##  #######  ##
  //  ##      ##   #####   ####    ##   ##  ######
  // モーダル開閉時に動画を止める
  window.addEventListener('click', function (e) {
    // 指定のクラスを持つ
    if (e.target.classList.contains('js-modal-open') || e.target.classList.contains('js-modal-close')) {
      player.pause()
    }
  })

  //  ##   ##   #####   ##      ##   ##  ###    ###  #####
  //  ##   ##  ##   ##  ##      ##   ##  ## #  # ##  ##
  //  ##   ##  ##   ##  ##      ##   ##  ##  ##  ##  #####
  //   ## ##   ##   ##  ##      ##   ##  ##      ##  ##
  //    ###     #####   ######   #####   ##      ##  #####
  // 音量設定の記憶
  saveVolume()
  function saveVolume() {
    player.on(['loadstart'], function (e) {
      // 動画準備段階
      const videoVolume = getCookie('videoVolume') // Cookie取得
      const videoMuted = getCookie('videoMuted') // Cookie取得
      if (videoMuted === 'true') {
        player.muted(true) // ミュートを反映
        setCookie('videoMuted', videoMuted, 60 * 60 * 24 * 365, false) // 音量をCookieに格納
      }
      if (!isNaN(videoVolume)) {
        player.volume(parseFloat(videoVolume, 10)) // 音量を反映
        setCookie('videoVolume', videoVolume, 60 * 60 * 24 * 365, false) // 音量をCookieに格納
      }
    })
    player.on('volumechange', function () {
      // 音量変更時
      setCookie('videoMuted', player.muted(), 60 * 60 * 24 * 365, false) // ミュート状態をCookieに格納
      setCookie('videoVolume', player.volume(), 60 * 60 * 24 * 365, false) // 音量をCookieに格納
    })
  }

  //    ###    #####   ##
  //   ## ##   ##  ##  ##
  //  ##   ##  #####   ##
  //  #######  ##      ##
  //  ##   ##  ##      ##
  // 再生状況送信API
  let playDataTimer
  let lastSendTime = 0 // 最後に送信した時間
  let seekTime = 0 // シークした時間
  player.on(['seeked'], function (e) {
    // シークされた
    const time = Math.floor(player.currentTime()) // 小数切り捨てで再生時間取得
    const endTime = Math.floor(player.duration()) // 動画全体の再生時間
    // console.log(time)
    if (lastSendTime + 5 <= time && time !== endTime) {
      // 最後の時間より5秒以上進んでおり、かつ動画の末尾でない場合は送信予約
      seekTime = time - (time % 5)
    }
  })

  // 初回再生時限定の送信
  let firstSend = false
  player.on(['play'], function (e) {
    if (!firstSend) {
      playTimeAPI(videoItem.dataset.token, secToTime(seekTime), 0)
      firstSend = true
    }
  })

  player.on(['playing'], function (e) {
    // シーク時の再生予約を実行
    // videoTrayOn()
    if (seekTime !== 0) {
      // シーク時間が0秒以外なら実行
      playTimeAPI(videoItem.dataset.token, secToTime(seekTime), 0)
      lastSendTime = seekTime
    }
    seekTime = 0

    // 定期送信処理を実行
    playDataTimer = setInterval(function () {
      const time = Math.floor(player.currentTime()) // 小数切り捨てで再生時間取得
      // console.log(time)
      if (time !== 0 && time % 5 === 0 && time !== lastSendTime) {
        // 0秒以外の5の倍数秒、かつ最後に記録した時間と異なれば送信する
        playTimeAPI(videoItem.dataset.token, secToTime(time), 0)
        lastSendTime = time
      }
    }, 500)
  })

  player.on(['pause'], function (e) {
    // 停止したら送信を止める
    clearInterval(playDataTimer)
  })
  player.on(['ended'], function (e) {
    // videoTrayOn()
    // 動画が終わったら送信する
    clearInterval(playDataTimer)
    const time = Math.floor(player.currentTime()) // 小数切り捨てで再生時間取得
    playTimeAPI(videoItem.dataset.token, secToTime(time), 1)
  })

  // 秒数skip
}

//  #####  ##   ##  ##     ##   ####  ######  ##   #####   ##     ##
//  ##     ##   ##  ####   ##  ##       ##    ##  ##   ##  ####   ##
//  #####  ##   ##  ##  ## ##  ##       ##    ##  ##   ##  ##  ## ##
//  ##     ##   ##  ##    ###  ##       ##    ##  ##   ##  ##    ###
//  ##      #####   ##     ##   ####    ##    ##   #####   ##     ##
function isDeviceOS() {
  const ua = navigator.userAgent.toLowerCase()
  if (ua.indexOf('iphone') > -1) {
    // iPhone
    return 'ios'
  }
  if (ua.indexOf('ipad') > -1) {
    // iPad
    return 'ios'
  }
  if (ua.indexOf('android') > -1 && ua.indexOf('mobile') > -1) {
    // Android
    return 'android'
  }
  if (ua.indexOf('android') > -1 && ua.indexOf('mobile') === -1) {
    // Android Tablet
    return 'android'
  }
  return 'pc'
}

//    ###    #####   ##            ######  ##  ###    ###  #####
//   ## ##   ##  ##  ##              ##    ##  ## #  # ##  ##
//  ##   ##  #####   ##  ########    ##    ##  ##  ##  ##  #####
//  #######  ##      ##              ##    ##  ##      ##  ##
//  ##   ##  ##      ##              ##    ##  ##      ##  #####

function playTimeAPI(token, time, finish = 0) {
  // Ajaxで再生情報を送信する

  // console.log(time)

  let ajax = new XMLHttpRequest() // Ajaxリクエスト

  ajax.open('get', playTimeApiUrl + '?token=' + token + '&time=' + time + '&finish=' + finish, true) // GET/POST, URL, 非同期処理

  ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー

  ajax.responseType = 'document' // 取得タイプ document text json
  ajax.timeout = 10000 // タイムアウト判定時間

  ajax.send() // GETリクエスト実行

  ajax.onload = function () {
    // アクセス成功
    if (ajax.status < 200 || ajax.status >= 400) {
      console.log('Error: Code ' + ajax.status) // エラー
    }
  }
  ajax.ontimeout = function (e) {
    // タイムアウト
  }
  ajax.onerror = function () {
    // Ajax処理失敗
  }
  ajax.onloadend = function () {
    // 受信成否に関わらず実行
    ajax = null
  }
}

//   ####  #####   ####            ######  ##  ###    ###  #####
//  ##     ##     ##                 ##    ##  ## #  # ##  ##
//   ###   #####  ##     ########    ##    ##  ##  ##  ##  #####
//     ##  ##     ##                 ##    ##  ##      ##  ##
//  ####   #####   ####              ##    ##  ##      ##  #####

/**
 * 総秒数を時:分:秒に変換
 * sec{int} 秒数
 */
function secToTime(sec) {
  // 時間を求める
  const hour = Math.floor(sec / 3600)
  sec %= 3600

  // 分を求める
  const minute = Math.floor(sec / 60)
  sec %= 60

  // 表示用にゼロパディングをかける
  const hourView = String(hour).padStart(2, '0')
  const minuteView = String(minute).padStart(2, '0')
  const secView = String(sec).padStart(2, '0')

  return hourView + ':' + minuteView + ':' + secView
}
